// extracted by mini-css-extract-plugin
export default {"listagem_titulo":"home_listagem_titulo__Nj+si","listagem_subtitulo":"home_listagem_subtitulo__+0AFt","paragrafo":"home_paragrafo__t-DY1","BannerInt":"home_BannerInt__sZPiD"};